import styled, { css } from "styled-components"
import { transparentize } from "polished"

const StyledWraper = styled.div`
  padding: 0.6rem 1.2rem;
  background-color: ${({ theme }) => theme.color.white};
  height: 3.2rem;
  display: flex;
  align-items: center;
  width: fit-content;
  box-shadow: 0px 0.2rem 0.4rem 0px
    ${({ theme }) => transparentize(0.88, theme.color.main01)};

  ${({ subType }) =>
    subType === "centred" &&
    css`
      position: absolute;
      bottom: 0.8rem;
      transform: translateX(-50%);
    `}
`
const StyledText = styled.p`
  font-family: ${({ theme }) => theme.font.family.body};
  font-size: ${({ theme }) => theme.font.size.xs};
  font-weight: ${({ theme }) => theme.font.weight.semiBold};
  line-height: 1.67;
  letter-spacing: 0.25px;
  color: ${({ theme }) => theme.color.secondary01};
  white-space: nowrap;
`
const StyledColorBox = styled.span`
  min-width: 0.8rem;
  min-height: 0.8rem;
  margin-right: 1.2rem;
  white-space: nowrap;

  ${({ color }) =>
    color &&
    css`
      background-color: ${color};
    `}
`

export { StyledWraper, StyledText, StyledColorBox }
